import { render, staticRenderFns } from "./NewCuentaEcp.vue?vue&type=template&id=5296a5f0"
import script from "./NewCuentaEcp.vue?vue&type=script&lang=js"
export * from "./NewCuentaEcp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports